/**
 * Step 3 Selector: Product, Study, and Environment Selection
 *
 * Migrated from: lego/page/etmf/overview/update-study/Step3Selector.jsx
 */

import React from 'react'
import { useServiceContext } from '../../../../root'
import { useDialogContext } from './context/useDialogContext'
import { Select, type OptionType } from '../../../../components/Select/Select'
import type { FormValues } from './context/DialogContext'
import { ErrorMessage } from 'formik'

interface Step3SelectorProps {
  values: FormValues
  setFieldValue: (field: string, value: any) => void
  setValues: (values: FormValues) => void
  reloadTable: (() => void) | null
}

export default function Step3Selector({ values, setFieldValue, setValues, reloadTable }: Step3SelectorProps) {
  const dialogData = useDialogContext()
  const context = useServiceContext()
  const { translate } = context.service.filter

  return (
    <>
      <div className="w50p form-group">
        <label htmlFor="product-select" className="control-label mb10">
          <span>{translate('SELECT_PRODUCT')}</span>
        </label>
        <Select
          name="product"
          placeholder={translate('SELECT_PRODUCT')}
          value={values.product}
          options={dialogData.productOptions}
          onChange={(option) => {
            const singleOption = option as OptionType | null
            dialogData.setCurrentValues(
              {
                product: singleOption ? singleOption.value : null,
                study: null,
                environment: null
              },
              setValues
            )
            dialogData.loadStudyOptions()
          }}
          id="product-select"
        />
        <ErrorMessage name="product" component="div" className="error-message text-danger" />
      </div>

      <div className="w50p form-group">
        <label htmlFor="study-select" className="control-label mb10">
          <span>{translate('SELECT_STUDY')}</span>
        </label>
        <Select
          name="study"
          placeholder={translate(
            values.product && !dialogData.isLoading && !dialogData.studyOptions.length
              ? 'ETMF_NO_STUDIES_EXIST'
              : 'SELECT_STUDY'
          )}
          value={values.study}
          isDisabled={!values.product}
          options={dialogData.studyOptions}
          onChange={(option) => {
            const singleOption = option as OptionType | null
            dialogData.setCurrentValues(
              {
                study: singleOption ? singleOption.value : null,
                environment: null
              },
              setValues
            )
            dialogData.loadEnvironmentOptions()
          }}
          id="study-select"
        />
        <ErrorMessage name="study" component="div" className="error-message text-danger" />
      </div>

      <div className="w50p form-group">
        <label htmlFor="environment-select" className="control-label mb10">
          <span>{translate('SELECT_ENVIRONMENT')}</span>
        </label>
        <Select
          name="environment"
          placeholder={translate(
            values.study && !dialogData.isLoading && !dialogData.environmentOptions.length
              ? 'ETMF_NO_ENVIRONMENTS_EXIST'
              : 'SELECT_ENVIRONMENT'
          )}
          value={values.environment}
          isDisabled={!values.study}
          options={dialogData.environmentOptions}
          onChange={(option) => {
            const singleOption = option as OptionType | null
            dialogData.setCurrentValues(
              {
                environment: singleOption ? singleOption.value : null
              },
              setValues
            )
            if (reloadTable) {
              reloadTable()
            }
          }}
          id="environment-select"
        />
        <ErrorMessage name="environment" component="div" className="error-message text-danger" />
      </div>
    </>
  )
}
